"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uwDecisionType = exports.productType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var productType = _propTypes.default.shape({
  id: _propTypes.default.string,
  rate: _propTypes.default.number,
  term: _propTypes.default.number,
  tier: _propTypes.default.number,
  min: _propTypes.default.number,
  max: _propTypes.default.number
});

exports.productType = productType;

var uwDecisionType = _propTypes.default.shape({
  applicationUuid: _propTypes.default.string,
  // intentionally left out status until defined
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  products: _propTypes.default.arrayOf(productType)
});

exports.uwDecisionType = uwDecisionType;